<template>
    <div>
        <transition enter-active-class="transition duration-100 ease-out"
            enter-from-class="transform scale-95 opacity-0" enter-to-class="transform scale-100 opacity-100"
            leave-active-class="transition duration-75 ease-in" leave-from-class="transform scale-100 opacity-100"
            leave-to-class="transform scale-95 opacity-0">
            <MenuItems
                class="absolute end-0 mt-8 z-50 
           w-96  max-h-screen origin-top-right divide-y divide-gray-100 rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div class=" h-[50vh] overflow-y-auto ">
                    <div  v-if="cartOrder && cartProducts" class="px-1 py-1" v-for=" (product, index ) of cartProducts" :key="product.id">
                        <MenuItem v-slot="{ active }">
                        <button @click="cartItemClick" :class="[
                            active ? '' : '',
                            'group flex w-full items-center rounded-md px-2 py-2 text-sm',
                        ]">
                            <div class="flex justify-between w-full">
                                <div class="  flex  items-center justify-start">
                                    <router-link :to="{
                                        name: 'product',
                                        params: { productSlug: product.slug? product.slug : product.id+'-'+product.title }
                                    }"
                                        class="_img  shadow lg:mb-0 me-4 rounded-lg w-[64px] min-w-[64px] max-w-[64px] max-h-[83px] h-[83px] flex flex-col justify-center items-center">
                                        <img v-if="product.image" :src="product.image"
                                            class="!rounded-lg w-full " />
                                        <img src="../../assets/images/placeholder-image.svg" v-else alt=""
                                            class="!rounded-lg w-full h-full" />
                                    </router-link>
                                    <div class="text-start flex flex-col justify-around h-full">
                                        <p class="lg:mb-2 text-sm font-normal line-clamp-2">{{ product.title }}</p>
                                        <p class=" text-sm font-bold text-dark-gray-3" v-if="product.discounted_price!= '0' && !cartOrder?.offer">
                                            {{ $filters.RTLNumbers(product.discounted_price) }} {{ t('currency.EGP') }}
                                            <span class=" text-xs  text-[#7B7B7B] me-2 line-through"> <span
															class=" ">{{
																$filters.RTLNumbers(product.price)
															}}</span>
														{{ t('currency.EGP') }}</span>
                                         </p>
                                         <p v-else class=" text-sm font-bold text-dark-gray-3">
                                            {{ $filters.RTLNumbers(product.price) }} {{ t('currency.EGP') }}
                                         </p>
                                    </div>
                                </div>
                                <div class="flex flex-col  items-center justify-between">
                                    <!--  delete button -->
                                    <a role="button" @click="confirmDeleteCartProduct(product)"
                                        class="w-5 h-5 p-[3px] bg-light-gray-14 rounded  inline-flex ms-auto justify-center items-center">
                                        <font-awesome-icon icon="xmark" class="w-full h-full text-secondary" />
                                    </a>
                                    <!-- quantities -->
                                    <div class="quantities flex ms-auto  lg:ms-auto items-center">
                                        <button
                                            class=" rounded-lg focus:outline-none disabled:opacity-50  !w-7 !h-7 max-w-7 max-h-7"
                                            @click="decreaseCartItemQuantity(product, index)"
                                            :disabled="cartProducts[index].quantity == 1">
                                            <font-awesome-icon icon="minus"
                                                class="text-[.5rem] p-[.6rem] rounded-lg border border-dark-4  " />
                                        </button>
                                        <input type="text" readonly id="quantity" v-model="cartProducts[index].quantity"
                                            class="border-0 w-5 h-5 p-0 mx-3 focus:ring-0 text-center" />
                                        <button @click="increaseCartItemQuantity(product, index)"
                                            :disabled="cartProducts[index].quantity >= cartProducts[index].maxQuantity"
                                            class=" rounded-lg  focus:outline-none disabled:opacity-50 !w-7 !h-7 max-w-7 max-h-7">
                                            <font-awesome-icon icon="plus"
                                                class="text-[.5rem] p-[.6rem] rounded-lg border border-dark-4  img-fluid" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </button>
                        </MenuItem>
                    </div>
                    <!-- In Case of Cart is Empty -->
                    <div v-if="cartProducts.length == 0"
                    class=" flex flex-col justify-center items-center bg-white  rounded-xl h-full w-full">
                        {{t('pages.cart_menu.Cart_Empty')}}
                        <router-link to="/categories" as="div" class="mx-2 font-medium inline-block hover:underline">
                            {{t('pages.cart_menu.Start_Shopping')}}
                        </router-link>
                    </div>
                </div>
                <!-- cart Footer -->

                <div class=" rounded-b-xl bottom-0 end-0 left-0 bg-[#EEEEEE] h-1/4 p-6">
                    <div class="flex justify-between mb-4">
                        <span class="font-bold ">{{t('currency.Total')}}</span>
                        <span class="total-price">
                            {{ $filters.RTLNumbers((cartOrder?.offer? cartOrder?.subtotal_price?.toFixed(2) : cartOrder?.subtotal_price_after_discount?.toFixed(2)) || '00.00') }} {{t('currency.EGP')}}</span>
                    </div>
                    <div class=" justify-between grid grid-cols-2 gap-4">
                        <RouterLink to="/view-cart" class=" w-full cursor-pointer">
                            <secondary-button class=" w-full cursor-pointer">
                                {{t('buttons.View_Cart')}}
                            </secondary-button>
                        </RouterLink>

                        <primary-button class=" w-full cursor-pointer" @click="onCheckout()"
                        :class="{ 'grayscale !text-dark-gray-7 !bg-light-gray-9 hover:bg-light-gray-9 hover:text-dark-gray-7 cursor-default ': cartProducts.length == 0 || isLessThanMinAmount }"
                        :disabled="cartProducts.length == 0 || isLessThanMinAmount">
                                {{t('buttons.Checkout')}}
                        </primary-button>
                    </div>
                    <p class="text-sm text-red text-start mt-1" v-if="isLessThanMinAmount && cartOrder.min_amount && cartProducts?.length >0 "> {{ t('pages.view_cart.minimum_order_amount')+' '+$filters.RTLNumbers(cartOrder.min_amount)+' '+ t('currency.EGP') }}</p>
                </div>
            </MenuItems>

        </transition>

        <!-- Start Login and Register Modals -->
        <TransitionRoot appear :show="isRegisterModal" as="template">
            <Register v-show="isRegisterModal && !isLoginModal" @openLoginModal="openLoginModal"
                @openOTPModal="openOTPModal" @openSendEmailModal="openSendEmailModal" @closeModals="closeModals" />
        </TransitionRoot>
        <TransitionRoot appear :show="isLoginModal" as="template">
            <Login v-show="isLoginModal && !isRegisterModal" @openRegisterModal="openRegisterModal"
                @openOTPModal="openOTPModal" @openSendEmailModal="openSendEmailModal" @closeModals="closeModals" />
        </TransitionRoot>

        <!-- End Login and Register Modals -->

        <!-- Start OTP Modal -->
        <TransitionRoot appear :show="isOTPModal" as="template">
            <otp-modal v-show="isOTPModal" @cancel="closeModals()">
            </otp-modal>
        </TransitionRoot>
        <!-- End OTPModal -->
    </div>
</template>
<script>
import { ref, computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex'
import { useRouter } from "vue-router"
import { useI18n } from "vue-i18n";

import Cart from '@/models/Cart'
import Response from "@/common/Response"
import Routes from "@/common/Routes"

// import AnchorButton from "@/components/atoms/buttons/AnchorButton"
import PrimaryButton from "@/components/atoms/buttons/PrimaryButton"
import SecondaryButton from "@/components/atoms/buttons/SecondaryButton"
import { MenuItem, MenuItems } from '@headlessui/vue'

//modals
import Login from "@/components/organisms/Login";
import Register from "@/components/organisms/Register";
import OtpModal from "@/components/organisms/OtpModal.vue";
import { TransitionRoot } from '@headlessui/vue';

export default {
    name: "app-nav",
    components: {
        // AnchorButton,
        PrimaryButton,
        SecondaryButton,
        MenuItem,
        MenuItems,
        TransitionRoot,
        //modals
        Login,
        Register,
        OtpModal,
    },
    emits:['isCartLoading'],
    setup(_,{emit}) {
        const { t } = useI18n();
        const store = useStore()
        const router = useRouter()

        const cartProducts = computed(() => store.getters.cartProducts)
        const cartOrder = computed(() => (store.getters.cartOrder) || {})
        const requestDelay = ref(0)
		const isLessThanMinAmount= computed(() =>(cartOrder.value?.total_after_discount < cartOrder.value?.min_amount? true : false))
        //modals
        const isLoading = ref(false)
        const isLoggedIn = computed(() => { return store.getters.isLoggedIn })
        const isVerified = computed(() => { return store.getters.isVerified })
        const isLoginModal = ref(false)
        const isRegisterModal = ref(false)
        const isOTPModal = ref(false)

        const confirmDeleteCartProduct = async function (productObj) {
            isLoading.value = true
            let params = {
                product_id: productObj.id,
                order_id: JSON.parse(localStorage.getItem('cart_order')).id,
            }
            await new Cart().deleteCartProduct(params).then(async (response) => {
                //update local storage and cart store
                if(response.data.length == 0 ) {
                    store.dispatch("updateCartOrder", {})
                    localStorage.removeItem('cart_order');
                } else {
                    const cartOrderResponse = response.data?.data
                    store.dispatch("updateCartOrder", cartOrderResponse)
                    localStorage.setItem('cart_order', JSON.stringify(cartOrderResponse));
                }
              

                //show success notification
                new Response({ message: t('messages.Product_Deleted_Successfully') }).displaySuccess()
                //hide modal
                isLoading.value = false
            }).catch((err) => {
                isLoading.value = false
            })

        };

        const updateCartProduct = function (productObj, productQuantity) {

            function addToCartRequest() {
                isLoading.value = true

                let payload = [{
                    product_id: productObj.id,
                    quantity: productQuantity
                }]
                new Cart().addToCart(payload).then((response) => {
                    //update local storage and cart store
                    const cartOrderResponse = response.data.data
                    store.dispatch("updateCartOrder", cartOrderResponse)
                    localStorage.setItem('cart_order', JSON.stringify(cartOrderResponse));
                    isLoading.value = false
                    //display success toaster
                    new Response({ message: t('messages.quantity_updated_successfully') }).displaySuccess()
                }).catch((err) => {
                    isLoading.value = false
                });
            }

            if (requestDelay.value) {
                clearTimeout(requestDelay.value);
                requestDelay.value = 0;
            }
            requestDelay.value = setTimeout(addToCartRequest, 500)
        }

        const onCheckout = function () {

            if (isLoggedIn.value) {
                if (isVerified.value.status) {
                    //got to checkout page
                    if (cartProducts.value.length > 0) {
                        router.push(Routes.CHECKOUT_PAGE)
                    }

                } else {
                    //show ask for verification popup with verify button 
                    isOTPModal.value = true
                }
            } else {
                //show register popup or login 
                isRegisterModal.value = true
            }
        }
        //modals methods 
        const openRegisterModal = function () {
            setTimeout(() => {
                isLoginModal.value = false
            })
            setTimeout(() => {
                isRegisterModal.value = true
            }, isLoginModal.value ? 350 : 0)
        }
        const openLoginModal = function () {

            setTimeout(() => {
                isRegisterModal.value = false
            })
            setTimeout(() => {
                isLoginModal.value = true
            }, isRegisterModal.value ? 350 : 0)
        }

        const openOTPModal = (async () => {
            setTimeout(() => {
                isLoginModal.value = false
                isRegisterModal.value = false
            })
            setTimeout(() => {
                isOTPModal.value = true
            }, 350)
        })

        onBeforeMount(async () => {
            emit('isCartLoading', true)
            await new Cart().getOrderGroupedByCategory().then((res) => {
                if (res.data) {
                    const cartOrder = res.data.data
                    store.dispatch("updateCartOrder", cartOrder)
                    if(cartOrder) {
                        localStorage.setItem('cart_order', JSON.stringify(cartOrder));
                    }
                }
                emit('isCartLoading', false)

            })
        })

        return {
            t,
            isLoading,
            isLoggedIn,
            isVerified,
            cartProducts,
            cartOrder,
			isLessThanMinAmount,
            increaseCartItemQuantity(product, productIndex) {
                cartProducts.value[productIndex].quantity = parseInt(cartProducts.value[productIndex].quantity) + 1
                let productQuantity = parseInt(cartProducts.value[productIndex].quantity)

                updateCartProduct(product, productQuantity)
            },
            decreaseCartItemQuantity(product, productIndex) {
                cartProducts.value[productIndex].quantity = parseInt(cartProducts.value[productIndex].quantity) - 1
                let productQuantity = parseInt(cartProducts.value[productIndex].quantity)

                updateCartProduct(product, productQuantity)
            },
            confirmDeleteCartProduct,
            cartItemClick(event) {
                event.preventDefault();
            },
            //modals
            isRegisterModal,
            isLoginModal,
            isOTPModal,
            openRegisterModal,
            openLoginModal,
            openOTPModal,
            onCheckout,
            closeModals() {
                isOTPModal.value = false
                isRegisterModal.value = false
                isLoginModal.value = false
            },
        }
    }
}
</script>
